import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgDataSourceNodeCard } from "../../../molecules/KgDataSourceNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const DataSourceFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgDataSourceNodeCard
      title={data.title ?? ""}
      subtitle={data.subtitle}
      logoUrl={data.logoUrl}
      iconColor={data.iconColor}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default DataSourceFlowNode;
